export const TemplateQueryKeys = {
  all: () => ["templates"],
};
